import { ITiers } from "../../../../types/spiffSetup";
import EligibilityTiers from "../EligibilityTiers";

interface TradesContentProps {
	tiers: ITiers[];
	tiersHeaderTitle: string;
	informationMessage: string;
	verticalText: string;
	commissionColumnsTitle: string;
	franchises: string[];
	spiffType: string;
}

const TradesContent = (props: TradesContentProps) => {
	const { tiers, tiersHeaderTitle, informationMessage, verticalText, commissionColumnsTitle, franchises, spiffType } = props;
	return (
		<EligibilityTiers
			franchises={franchises}
			tiers={tiers}
			tiersHeaderTitle={tiersHeaderTitle}
			informationMessage={[informationMessage]}
			verticalText={verticalText}
			commissionColumnsTitle={commissionColumnsTitle}
			spiffType={spiffType}
		/>
	);
};

export default TradesContent;
